module.exports = __webpack_public_path__ + "static/media/Infografia_sectorial_INEGI.4b0cc4d0.pdf";